import React from 'react';
import { connect } from 'react-redux';

import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';


import {
  fetchSets,
  createSets,
  updateSets,
  deleteSets,
} from '../../store/actions/sets';

import ContentHeader from '../../components/ContentHeader/ContentHeader';
import DataTable from '../../components/DataTable/DataTable';

class SetList extends React.Component {
  state = {
    openModal: false,
    currentItem: {
      id: null,
      description: '',
      percentExtraHours: '',
      percentExtraNight: '',
      percentExtraHoursSundayOrHoliday: '',
    },
    currentAction: null,
  };

  componentDidMount() {
    this.props.onFetchSets();
  }

  handleActionClick = (action, item) => {
    if (item) {
      item = this.props.sets.filter(s => s.id === item.id)[0];
      this.setState({ openModal: true, currentItem: item, currentAction: action });
    } else {
      this.setState({
        openModal: true,
        currentItem: { id: null, description: '', 
        percentExtraHours: '', percentExtraNight: '',
        percentExtraHoursSundayOrHoliday: '', },
        currentAction: action,
      });
    }
  };

  handleActionCancel = () => {
    this.setState({ openModal: false });
  };

  handleActionConfirm = (event) => {
    event.preventDefault();
    if (this.state.currentAction === 'Adicionar') {
      this.props.onCreateSets({ 
          description: this.state.currentItem.description, 
          percentExtraHours: this.state.currentItem.percentExtraHours,
          percentExtraNight: this.state.currentItem.percentExtraNight,
          percentExtraHoursSundayOrHoliday: this.state.currentItem.percentExtraHoursSundayOrHoliday
                                
        });
    }
    if (this.state.currentAction === 'Editar') {
      this.props.onUpdateSets(this.state.currentItem);
    }
    if (this.state.currentAction === 'Excluir') {
      this.props.onDeleteSets(this.state.currentItem.id);
    }
    this.handleActionCancel();
  };

  handleChangeExtraHours = event => {
    this.setState({ 
        currentItem: { ...this.state.currentItem, percentExtraHours: event.target.value } 
    });
  };

  handleChangeExtraNight = event => {
    this.setState({ 
        currentItem: { ...this.state.currentItem, percentExtraNight: event.target.value } 
    });
  };

  handleChangeSundayOrHoliday = event => {
    this.setState({ 
        currentItem: { ...this.state.currentItem, percentExtraHoursSundayOrHoliday: event.target.value } 
    });
  };

  handleChangeText = (event) => {
    this.setState({
      currentItem: { ...this.state.currentItem, description: event.target.value },
    });
  };

  render() {
    const { loading, sets } = this.props;
    const { currentItem, currentAction } = this.state;

    const columns = [{ name: 'description', label: 'Configurações' }];

    const actions = [
      {
        name: 'Editar',
        icon: EditIcon,
        onClick: item => this.handleActionClick('Editar', item),
      },
      {
        name: 'Excluir',
        icon: DeleteIcon,
        onClick: item => this.handleActionClick('Excluir', item),
      },
    ];

    return (
      <React.Fragment>
        <ContentHeader
          title="Configurão de Funcionários"
          subtitle="Configure aqui as horas extras de seus funcionários "
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => this.handleActionClick('Adicionar')}
          >
            <AddIcon /> ADICIONAR
          </Button>
        </ContentHeader>

        <Paper elevation={2}>
          <DataTable rows={sets || []} columns={columns} actions={actions} loading={loading} />
        </Paper>

        <Dialog open={this.state.openModal} onClose={this.handleActionCancel}>
          <DialogTitle>{currentAction} Configuração </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {currentAction === 'Excluir'
                ? 'Você tem certeza que deseja efetuar esta ação?'
                : 'Por favor, preencha o campo a seguir com as configurações correspondentes'}
            </DialogContentText>
            {currentAction !== 'Excluir' ? (
              <form onSubmit={this.handleActionConfirm}>
              <TextField
                  autoFocus
                  margin="dense"
                  name="description"
                  label="Nome da configuração"
                  type="text"
                  onChange={this.handleChangeText}
                  value={currentItem.description}
                  fullWidth
                  required
                />
                Hora Extra diurna: 
                <Select
            value={currentItem.percentExtraHours}
            onChange={this.handleChangeExtraHours}
            input={<Input name="percentExtraHours" id="age-helper1" />}
            displayEmpty
            style={{ margin: 10 }}
          >
            <MenuItem value={currentItem.percentExtraHours}>
            
            </MenuItem>
            <MenuItem value={1.2}>1.2x</MenuItem>
            <MenuItem value={1.3}>1.3x</MenuItem>
            <MenuItem value={1.5}>1.5x</MenuItem>
          </Select> <br />
          Porcetagem hora extra noturno: 
                <Select
            value={currentItem.percentExtraNight}
            onChange={this.handleChangeExtraNight}
            input={<Input name="name" id="age-helper3" />}
            displayEmpty
            style={{margin: 10  }}
          >
            <MenuItem value={currentItem.percentExtraNight}>
            
            </MenuItem>
            <MenuItem value={1.2}>1.2x</MenuItem>
            <MenuItem value={1.3}>1.3x</MenuItem>
            <MenuItem value={1.5}>1.5x</MenuItem>
          </Select><br />
          Porcetagem hora adicional Feriado / Domingo: 
                <Select
            value={currentItem.percentExtraHoursSundayOrHoliday}
            onChange={this.handleChangeSundayOrHoliday}
            input={<Input name="name" id="age-helper4" />}
            displayEmpty
            style={{margin: 10  }}
          >
            <MenuItem value={currentItem.percentExtraHoursSundayOrHoliday}>
            
            </MenuItem>
            <MenuItem value={1.2}>1.2x</MenuItem>
            <MenuItem value={1.3}>1.3x</MenuItem>
            <MenuItem value={1.5}>1.5x</MenuItem>
          </Select><br />
              </form>
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleActionCancel}>CANCELAR</Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={this.handleActionConfirm}
              autoFocus={currentAction === 'Excluir'}
            >
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return ({
  loading: state.general.loading,
  sets: state.sets.sets,
  })
};

const mapDispatchToProps = dispatch => ({
  onFetchSets: () => dispatch(fetchSets()),
  onCreateSets: data => dispatch(createSets(data)),
  onUpdateSets: data => dispatch(updateSets(data)),
  onDeleteSets: id => dispatch(deleteSets(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SetList);
